import {DtoMapper} from '@wemogy/reactbase';
import {IInvitation} from '../../models/Invitation';

export default class InvitationDtoMapper extends DtoMapper<IInvitation, any>{

}
